export default "__VITE_ASSET__RwJ5MH5R__"